module.exports = __webpack_public_path__ + "static/media/Logo_AdminPortal.6ecd44f9.png";